import {getRecaptchaLocale} from 'app/utils/recaptchaConfig';

const RECAPTCHA_V2_SCRIPT_ID = 'google-recaptcha-v2-explicit';
const RECAPTCHA_V2_CALLBACK = 'onRecaptchaV2ExplicitLoad';

let loadPromise = null;
let v2ScriptLoaded = false;

export const isRecaptchaV2Available = () => v2ScriptLoaded && window.grecaptcha && typeof window.grecaptcha.render === 'function';

const waitForRecaptchaV2 = resolve => {
    if (isRecaptchaV2Available()) {
        resolve();
        return;
    }

    setTimeout(() => waitForRecaptchaV2(resolve), 100);
};

export const loadRecaptchaV2Script = () => {
    if (isRecaptchaV2Available()) {
        return Promise.resolve();
    }

    if (loadPromise) {
        return loadPromise;
    }

    loadPromise = new Promise((resolve, reject) => {
        if (document.getElementById(RECAPTCHA_V2_SCRIPT_ID)) {
            waitForRecaptchaV2(resolve);
            return;
        }

        window[RECAPTCHA_V2_CALLBACK] = () => {
            v2ScriptLoaded = true;
            resolve();
        };

        const script = document.createElement('script');
        script.id = RECAPTCHA_V2_SCRIPT_ID;
        script.src = `https://www.google.com/recaptcha/api.js?onload=${RECAPTCHA_V2_CALLBACK}&render=explicit&hl=${getRecaptchaLocale()}`;
        script.async = true;
        script.defer = true;
        script.onerror = () => {
            loadPromise = null;
            reject(new Error('Failed to load reCAPTCHA v2'));
        };
        document.head.appendChild(script);
    });

    return loadPromise;
};
